var RecentInstagramComponent = {};

RecentInstagramComponent.init = function () {
  if($(window).width() < 768 && $('section.instagram').length) {
    $('.recent-instagram-photos-container').slick({
      dots: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2
    });
  } else if ($(window).width() < 993 && $('section.instagram').length) {
    $('.recent-instagram-photos-container').slick({
      dots: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 2
    });
  }
};

$(document).ready(function(){
  RecentInstagramComponent.init();
});